import * as COM from '../components';
const membetManagement = [
  /** ------------------------------ 权益管理 ------------------------------ */
  {
    path: '/member-list',
    component: COM.Layout,
    redirect: '/member-list/index',
    name: 'vip__memberList',
    meta: { label: '会员列表' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 会员列表
      {
        path: '/member-list/index',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.MemberListIndex,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'memberListIndex',
        meta: { label: '会员列表', icon: 'el-icon-document', menuKeyPath: '/member-list/index' }
      },
      // 会员列表内页
      {
        path: '/member-list/index',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/member-list/index/detail',
        name: 'memberListdetailInside',
        meta: { label: '会员列表', insidePageFrom: 'memberListIndex' },
        children: [
          {
            path: 'detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.MemberListDetail
            },
            name: 'memberListDetail',
            meta: { label: '会员详情', icon: 'el-icon-document', menuKeyPath: '/member-list/index', authKey: 'memberListIndex' }
          },
          {
            path: 'export-record',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.MemberExportRecord
            },
            name: 'memberExportRecord',
            meta: { label: '导出记录', icon: 'el-icon-document', menuKeyPath: '/member-list/index', authKey: '#memberListIndex.modify' }
          }
        ]
      },
      // 黑名单列表
      {
        path: 'black-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.BlackList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'blackList',
        meta: { label: '黑名单列表', icon: 'el-icon-document', menuKeyPath: '/member-list/black-list' }
      }
    ]
  },
  /** ------------------------------ 等级管理 ------------------------------ */
  {
    path: '/member-level',
    component: COM.Layout,
    redirect: '/member-level/member-level-rule',
    name: 'vip__memberLevel',
    meta: { label: '等级管理' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 等级规则
      {
        path: 'member-level-rule',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.MemberLevelRule,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'memberLevelRule',
        meta: { label: '等级规则', icon: 'el-icon-document', menuKeyPath: '/member-level/member-level-rule' }
      },
      // 新增等级规则
      {
        path: '/member-level/member-level-rule',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/member-level/member-level-rule/member-level-right-add',
        name: 'memberLevelRuleAdd',
        meta: { label: '等级规则', insidePageFrom: 'memberLevelRule' },
        children: [
          {
            path: 'member-level-right-add',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.MemberLevelRightAdd
            },
            name: 'memberLevelRightAdd',
            meta: { label: '新增等级规则', icon: 'el-icon-document', menuKeyPath: '/member-level/member-level-rule', authKey: '#memberLevelRule.add' }
          },
          {
            path: 'member-level-right-edit',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.MemberLevelRightAdd
            },
            name: 'memberLevelRightEdit',
            meta: { label: '编辑等级规则', icon: 'el-icon-document', menuKeyPath: '/member-level/member-level-rule', authKey: '#memberLevelRule.modify' }
          }
        ]
      },
      // 商品编码
      {
        path: 'commodity-code',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.CommodityCode,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'commodityCode',
        meta: { label: '商品编码', icon: 'el-icon-document', menuKeyPath: '/member-level/commodity-code' }
      },
    ]
  },
  /** ------------------------------ 成长管理 ------------------------------ */
  {
    path: '/member-growth',
    component: COM.Layout,
    redirect: '/member-growth/member-growth-rule',
    name: 'vip__memberGrowth',
    meta: { label: '成长管理' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 成长规则
      {
        path: 'member-growth-rule',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.MemberGrowthRule,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'memberGrowthRule',
        meta: { label: '成长规则', icon: 'el-icon-document', menuKeyPath: '/member-growth/member-growth-rule' }
      },
      // 新增成长值任务
      {
        path: '/member-growth/member-growth-rule',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/member-growth/member-growth-rule/member-growth-rule-create',
        name: 'memberGrowthRuleAdd',
        meta: { label: '成长规则', insidePageFrom: 'memberGrowthRule' },
        children: [
          {
            path: 'member-growth-rule-create',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.MemberGrowthRuleCreate
            },
            name: 'memberGrowthRuleCreate',
            meta: { label: '新增成长值任务', icon: 'el-icon-document', menuKeyPath: '/member-growth/member-growth-rule', authKey: '#_memberGrowthRule.add' }
          },
          {
            path: 'member-growth-rule-edit',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.MemberGrowthRuleCreate
            },
            name: 'memberGrowthRuleEdit',
            meta: { label: '编辑成长值任务', icon: 'el-icon-document', menuKeyPath: '/member-growth/member-growth-rule', authKey: '#_memberGrowthRule.modify' }
          },
          {
            path: 'member-growth-rule-detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.MemberGrowthRuleCreate
            },
            name: 'memberGrowthRuleDetail',
            meta: { label: '成长值任务详情', icon: 'el-icon-document', menuKeyPath: '/member-growth/member-growth-rule', authKey: '#_memberGrowthRule.detail' }
          }
        ]
      },
      // 成长值流水
      {
        path: 'member-growth-list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.MemberGrowthList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'memberGrowthList',
        meta: { label: '成长值流水', icon: 'el-icon-document', menuKeyPath: '/member-growth/member-growth-list' }
      },
      // 成长值流水导出记录
      {
        path: '/member-growth/member-growth-list',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/member-growth/member-growth-list/growth-export-record',
        name: 'memberGrowthListEdit',
        meta: { label: '成长值流水', insidePageFrom: 'memberGrowthList' },
        children: [
          {
            path: 'growth-export-record',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.MemberExportRecord
            },
            name: 'growthMemberExportRecord',
            meta: { label: '导出记录', icon: 'el-icon-document', menuKeyPath: '/member-growth/member-growth-list', authKey: '#memberGrowthList.modify' }
          }
        ]
      },
      // 成长值修改
      {
        path: 'member-growth-edit',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.MemberGrowthEdit,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'memberGrowthEdit',
        meta: { label: '成长值修改', icon: 'el-icon-document', menuKeyPath: '/member-growth/member-growth-edit' }
      }
    ]
  },
  /** ------------------------------ 积分管理 ------------------------------ */
  {
    path: '/integral-management',
    component: COM.Layout,
    redirect: '/integral-management/integral-rule',
    name: 'vip__IntegralManagement',
    meta: { label: '积分管理' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 积分规则
      {
        path: 'integral-rule',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.IntegralRule,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'integralRule',
        meta: { label: '积分规则', icon: 'el-icon-document', menuKeyPath: '/integral-management/integral-rule' }
      },
      // 新增积分规则
      {
        path: '/integral-management/integral-rule',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/integral-management/integral-rule/add',
        name: 'integralRuleAdd',
        meta: { label: '积分规则', insidePageFrom: 'integralRule' },
        children: [
          {
            path: 'add',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AddIntegralRule
            },
            name: 'addIntegralRule',
            meta: { label: '新增积分规则', icon: 'el-icon-document', menuKeyPath: '/integral-management/integral-rule', authKey: '#integralRule.add' }
          },
          {
            path: 'edit',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AddIntegralRule
            },
            name: 'editIntegralRule',
            meta: { label: '编辑积分规则', icon: 'el-icon-document', menuKeyPath: '/integral-management/integral-rule', authKey: '#integralRule.modify' }
          },
          {
            path: 'details',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AddIntegralRule
            },
            name: 'detailsIntegralRule',
            meta: { label: '积分规则详情', icon: 'el-icon-document', menuKeyPath: '/integral-management/integral-rule', authKey: 'integralRule' }
          }
        ]
      },
      // 积分流水
      {
        path: 'integral-stream',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.IntegralStream,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'integralStream',
        meta: { label: '积分流水', icon: 'el-icon-document', menuKeyPath: '/integral-management/integral-stream' }
      },
      // 积分流水导出记录
      {
        path: '/integral-management/integral-stream',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/integral-management/integral-stream/integral-export-record',
        name: 'integralStreamEdit',
        meta: { label: '积分流水', insidePageFrom: 'integralStream' },
        children: [
          {
            path: 'integral-export-record',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.MemberExportRecord
            },
            name: 'integralMemberExportRecord',
            meta: { label: '导出记录', icon: 'el-icon-document', menuKeyPath: '/integral-management/integral-stream', authKey: '#integralStream.modify' }
          }
        ]
      },
      // 积分修改
      {
        path: 'integral-edit',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.IntegralEdit,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'integralEdit',
        meta: { label: '积分修改', icon: 'el-icon-document', menuKeyPath: '/integral-management/integral-edit' }
      },
      // 额外积分规则
      {
        path: 'extra-integral-rule',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.ExtraIntegralRule,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'extraIntegralRule',
        meta: { label: '额外积分规则', icon: 'el-icon-document', menuKeyPath: '/integral-management/extra-integral-rule' }
      },
      // 新增额外积分规则
      {
        path: '/integral-management/extra-integral-rule',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/integral-management/extra-integral-rule/add',
        name: 'extraIntegralRuleAdd',
        meta: { label: '额外积分规则', insidePageFrom: 'extraIntegralRule' },
        children: [
          {
            path: 'add',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AddExtraIntegralRule
            },
            name: 'addExtraIntegralRule',
            meta: { label: '新增额外积分规则', icon: 'el-icon-document', menuKeyPath: '/integral-management/extra-integral-rule', authKey: '#extraIntegralRule.add' }
          },
          {
            path: 'edit',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AddExtraIntegralRule
            },
            name: 'editExtraIntegralRule',
            meta: { label: '编辑额外积分规则', icon: 'el-icon-document', menuKeyPath: '/integral-management/extra-integral-rule', authKey: '#extraIntegralRule.modify' }
          },
          {
            path: 'see',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.AddExtraIntegralRule
            },
            name: 'seeExtraIntegralRule',
            meta: { label: '查看额外积分规则', icon: 'el-icon-document', menuKeyPath: '/integral-management/extra-integral-rule', authKey: 'extraIntegralRule' }
          }
        ]
      },
    ]
  },
  /** ------------------------------ 积分池管理 ------------------------------ */
  {
    path: '/integral-pool',
    component: COM.Layout,
    redirect: '/integral-pool/list',
    name: 'vip__IntegralPool',
    meta: { label: '积分池管理' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 积分池列表
      {
        path: 'list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.IntegralPoolList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'integralPoolList',
        meta: { label: '积分池列表', icon: 'el-icon-document', menuKeyPath: '/integral-pool/list' }
      },
      // 积分池预警
      {
        path: 'warning',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.IntegralPoolWarning,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'integralPoolWarning',
        meta: { label: '积分池预警', icon: 'el-icon-document', menuKeyPath: '/integral-pool/warning' }
      },
      // 积分池审核
      {
        path: 'examine',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.IntegralPoolExamine,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'integralPoolExamine',
        meta: { label: '积分池审核', icon: 'el-icon-document', menuKeyPath: '/integral-pool/examine' }
      },
      // 积分池流水
      {
        path: 'stream',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.IntegralPoolStream,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'integralPoolStream',
        meta: { label: '积分池流水', icon: 'el-icon-document', menuKeyPath: '/integral-pool/stream' }
      },
      // 积分采购
      {
        path: 'purchase',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.IntegralPurchase,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'integralPurchase',
        meta: { label: '积分采购管理', icon: 'el-icon-document', menuKeyPath: '/integral-pool/purchase' }
      }
    ]
  },

  /** ------------------------------ 勋章管理 ------------------------------ */
  {
    path: '/medal',
    component: COM.Layout,
    redirect: '/medal/rule',
    name: 'vip__medal',
    meta: { label: '勋章管理' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 勋章规则
      {
        path: 'rule',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.MedalManagement,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'medalManagement',
        meta: { label: '勋章规则', icon: 'el-icon-document', menuKeyPath: '/medal/rule' }
      },
      // 新增编辑勋章规则
      {
        path: '/medal/rule',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/medal/rule/add',
        name: 'medalManagementLayout',
        meta: { label: '勋章规则', insidePageFrom: 'medalManagement' },
        children: [
          {
            path: '/medal/rule/add',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.MedalManagementAdd
            },
            name: 'medalManagementAdd',
            meta: { label: '新增勋章规则', icon: 'el-icon-document', menuKeyPath: '/medal/rule', authKey: '#medalManagement.add' }
          },
          {
            path: '/medal/rule/edit',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.MedalManagementAdd
            },
            name: 'medalManagementEdit',
            meta: { label: '编辑勋章规则', icon: 'el-icon-document', menuKeyPath: '/medal/rule', authKey: '#medalManagement.modify' }
          }
        ]
      }
    ]
  },
  /** ------------------------------ 任务中心 ------------------------------ */
  {
    path: '/task',
    component: COM.Layout,
    redirect: '/task/list',
    name: 'vip__task',
    meta: { label: '任务中心' },
    /** ------------------------------ 二级页面 ------------------------------ */
    children: [
      // 任务中心
      {
        path: 'list',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.TaskList,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'taskList',
        meta: { label: '任务管理', icon: 'el-icon-document', menuKeyPath: '/task/list' }
      },
      // 新增任务
      {
        path: '/task/list',
        components: {
          bodyView: COM.DetailLayout,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        redirect: '/task/list/add',
        name: 'taskListLayout',
        meta: { label: '任务管理', insidePageFrom: 'taskList' },
        children: [
          {
            path: '/task/list/add',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.TaskListAdd
            },
            name: 'taskListAdd',
            meta: { label: '新增任务', icon: 'el-icon-document', menuKeyPath: '/task/list', authKey: '#_taskList.add' }
          },
          {
            path: '/task/list/edit',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.TaskListAdd
            },
            name: 'taskListEdit',
            meta: { label: '编辑任务', icon: 'el-icon-document', menuKeyPath: '/task/list', authKey: '#_taskList.modify' }
          },
          {
            path: '/task/list/detail',
            icon: 'el-icon-document',
            components: {
              bodyView: COM.TaskListAdd
            },
            name: 'taskListDetail',
            meta: { label: '任务详情', icon: 'el-icon-document', menuKeyPath: '/task/list', authKey: '#_taskList.detail' }
          }
        ]
      },
      // 任务池管理
      {
        path: 'taskPool',
        icon: 'el-icon-document',
        components: {
          bodyView: COM.TaskPool,
          appHeader: COM.NavHeader,
          bodyHeader: COM.BodyHeader,
          secondMenu: COM.SecondMenu
        },
        name: 'taskPool',
        meta: { label: '任务池管理', icon: 'el-icon-document', menuKeyPath: '/task/taskPool' }
      },
    ]
  },
];

export default membetManagement;
